import type { Supplier } from "@albertine/types";
import type { Agent } from "../../common/types/Agent";
import Button from "../Common/Buttons";
import { Flex } from "../Common/Flex";
import Icon from "../Common/Icon";
import FullScreenOverlay from "../Common/Overlay/FullScreenOverlay";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import CatalogItemHeader from "./CatalogItemHeader";
import CatalogItemView from "./CatalogItemView";
import ItemNotFound from "./ItemNotFound";
import "./ViewCatalogItem.css";
import type { CatalogItemFull } from "@albertine/types/openapi/lmt";
import type { Request } from "../../common/types/Request";
import { useClaims } from "../../utils/claims.util";
import WithCatalogItem from "./WithCatalogItem";

type EditCatalogItemProps = {
    catalogItemId: string;
    currentAgent: Agent;
    googlePlaceService: google.maps.places.PlacesService;
    suppliers: Supplier[];
    distanceOrigin?: { lat: number; lng: number };
    onBack?: () => void;
    onEdit?: (item: CatalogItemFull) => void;
    onClose: () => void;
    onToggleArchive: (item: CatalogItemFull) => void;
    request?: Request;
    selectCatalogItem?: (item: CatalogItemFull) => void;
    sendItemToCart?: (item: CatalogItemFull) => void;
    cartItems?: string[];
};

function ViewCatalogItem(props: EditCatalogItemProps) {
    const {
        catalogItemId,
        googlePlaceService,
        suppliers,
        distanceOrigin,
        onBack,
        onEdit,
        onClose,
        onToggleArchive,
        request,
        selectCatalogItem,
        sendItemToCart,
        cartItems,
    } = props;
    const { isAdmin } = useClaims();

    return (
        <FullScreenOverlay>
            <WithCatalogItem
                catalogId={catalogItemId}
                renderOnError={
                    <ItemNotFound
                        contentItemId={catalogItemId}
                        onClose={() => {
                            onClose();
                        }}
                    />
                }
                renderLoading={
                    <Flex.Column
                        className="view-catalog-item__loading"
                        alignItems="center"
                        justifyContent="center"
                    >
                        <LoadingSpinner />
                    </Flex.Column>
                }
            >
                {(catalogItem) => (
                    <>
                        <Flex.Row gap="medium" className="view-catalog-item-actions">
                            {onBack && (
                                <Button.Ghost onClick={onBack}>
                                    <Icon.ArrowBack.Medium.N10 />
                                </Button.Ghost>
                            )}

                            <Flex.Row justifyContent="space-between">
                                <CatalogItemHeader
                                    item={catalogItem}
                                    cartItems={cartItems || []}
                                    selectCatalogItem={selectCatalogItem || (() => {})}
                                    request={request}
                                    sendItemToCart={sendItemToCart}
                                />

                                {!onBack && (
                                    <Button.Ghost onClick={onClose}>
                                        <Icon.Close.Medium.N10 />
                                    </Button.Ghost>
                                )}
                            </Flex.Row>
                        </Flex.Row>
                        <CatalogItemView
                            mapId="catalog-beta_view__item-full"
                            googlePlaceService={googlePlaceService}
                            item={catalogItem}
                            suppliers={suppliers}
                            isAdmin={isAdmin}
                            distanceOrigin={distanceOrigin}
                            onToggleArchive={onToggleArchive}
                            onEdit={onEdit}
                        />
                    </>
                )}
            </WithCatalogItem>
        </FullScreenOverlay>
    );
}

export default ViewCatalogItem;
